<template>
  <v-btn
    v-if="value"
    icon
    small
    v-clipboard:copy="value"
    v-clipboard:success="
      (e) => {
        onCopy(e)
        $emit('copySuccess', e)
      }
    "
    v-clipboard:error="onError"
    v-tooltip="getTooltipHtml(value)"
  >
    <v-icon v-if="copied" small color="green" key="copied-check"
      >mdi-check</v-icon
    >
    <v-icon
      v-else
      small
      @mouseenter="isHovering = true"
      @mouseleave="isHovering = false"
      >{{ isHovering ? 'mdi-content-copy' : icon }}</v-icon
    >
  </v-btn>
</template>

<script>
export default {
  name: 'AdminCellCopyTextPopup',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    width: {
      type: [String, Number],
      default: null,
    },
    icon: {
      type: String,
      default: 'mdi-note-outline',
    },
  },
  data() {
    return {
      isHovering: false,
      copied: false,
    }
  },
  computed: {
    containerStyles() {
      let maxWidth =
        typeof this.width === 'number' ? `${this.width}px` : this.width
      return {
        maxWidth,
      }
    }, // containerStyles
  }, // computed
  methods: {
    onCopy() {
      this.copied = true
      setTimeout(() => {
        this.copied = false
        this.isHovering = false
      }, 2000)
    },
    onError: function() {
      alert('Failed to copy the text to the clipboard')
    },
    getTooltipHtml(value) {
      return {
        content: this.copied
          ? '<div class="proxima--font">Copied!</div>'
          : `<div class="proxima--font">${value}</div><div class="proxima--font font-italic">(Click icon to copy)</div>`,
        html: true,
        triggers: ['hover', 'click'],
      }
    }, // getTooltipHtml
  },
}
</script>
